import { T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS } from './TYPES'

const EN_TERMS_AND_CONDITIONS_PAGE_CONSTANTS: T_TERMS_AND_CONDITIONS_PAGE_CONSTANTS =
  {
    PAGE_KICKER: 'GRIFFYREADS',
    PAGE_TITLE: 'Terms and Conditions',
    PAGE_CONTENT: [
      {
        TITLE: 'Introduction',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Welcome to GriffyReads. These Terms and Conditions ("Terms") govern the use of our quiz-based application, called GriffyReads, designed for children and adults ("the App"). By accessing or using the Application, adult users accept these Terms.',
              'The aim of the App is to promote offline reading among children. To this end, the Application offers a database of multiple-choice quizzes that test reading comprehension. At the same time, it functions as a community platform, as any adult user (parents, teachers, etc.) can upload quizzes.',
              'Children — referred to as “adventurers”— use the platform by selecting a specific book, reading it offline, and then completing a quiz consisting of five multiple-choice questions designed to test their comprehension of the text. They earn points for correct answers, which contribute to the development of their mascot character, a young griffin named Griffy. Adventurers can play individually or take part in events and competitions organized by adult users, alongside other adventurers. The platform only includes some specific identifying information about each book (e.g., author, publisher, cover image), but not the book itself.'
            ]
          }
        ]
      },
      {
        TITLE: 'Users and registration',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'The App is intended for use by adults and children. “Adult” means a person who has reached the age of majority, that is 18 years. Children under the age of 13 years may only use the App under the supervision of an adult.',
              'Adult users may create competitions for children and are encouraged to upload new quizzes.',
              'To use the App, adult users must register by providing specific data. To log in, they use an email address and password. Only adults are allowed to register an account. Once registered, they may create a child (adventurer) account. Thereafter, adventurers may log in themselves in their account.',
              'After registration, there is a trial period for 14 days. Adult users should choose a subscription plan to have full access to the app beyond the trial period.',
              'Adult users are responsible for ensuring the accuracy of the information provided during registration.'
            ]
          }
        ]
      },
      {
        TITLE: 'Use of the App',
        CONTENT: [
          {
            TYPE: 'LIST',
            CONTENT: [
              'Participation in quizzes: Children (adventurers) read the selected book (or for younger children, it is read aloud to them), and then they complete quizzes in the App to test their understanding of the text. Each correct answer earns points, which help their Griffy grow stronger and larger. Earning points also leads to leveling up and character development.',
              'Competitions and events: Adult users can create competitions for adventurers to participate in (typically, these competitions will be organised by teachers for their students). The administrators of the App can create so-called events, which are public competitions typically open to larger groups (e.g. age groups).',
              'All participants can view their rankings on the leaderboard (the organiser of the competition or event has the option to anonymise the leaderboard), and badges are awarded to top rankers.',
              'Virtual library and exchange of books: Children can create a “virtual library” in the App from the books they already own and indicate their intention to share these books with their friends within the App.',
              "List of Friends: Children can add other children to their friends list, allowing them to view each other's books and making it easier to exchange books and stay in touch."
            ]
          }
        ]
      },
      {
        TITLE: 'Content and Conduct',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Adult users are responsible for the content they provide and their conduct while using the App. Any inappropriate, offensive, or harmful content or behaviour may result in account suspension or termination.',
              'By uploading, submitting, or otherwise making available any quizzes or related content (“User Content”) through the App, adult users agree that such content becomes the sole and exclusive intellectual property of Adonis Consultancy. Adult users hereby irrevocably assign, transfer, and convey to Adonis Consultancy all rights, title, and interest in and to the User Content, including without limitation all copyrights and any other intellectual property rights therein.',
              'Adult users further acknowledge and agree that Adonis Consultancy shall have the unrestricted right to use, reproduce, modify, distribute, display, perform, and otherwise exploit the User Content for any purpose, commercial or otherwise, without compensation, attribution, or further notice to them.',
              'By submitting content, adult users represent and warrant to have all necessary rights and permissions to grant this assignment, and that the content does not infringe on any third-party rights.'
            ]
          }
        ]
      },
      {
        TITLE: 'Privacy',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'Your use of the App is also governed by our Privacy Policy, which details how the Controller collects, uses, and protects your personal information.'
            ]
          }
        ]
      },
      {
        TITLE: 'Subscription and Payment',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'The App operates on a subscription model, where adult users pay a specific amount corresponding to a subscription plan to provide their children with access to the platform once the 14-day trial period has expired. Several subscription plans are offered.',
              'Payments are processed through PayPal. By subscribing to a specific subscription plan, adult users agree to pay the corresponding subscription fees and any applicable taxes.'
            ]
          }
        ]
      },
      {
        TITLE: 'Modifications to the App',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'We reserve the right to modify or discontinue the App, temporarily or permanently, with or without notice. We are not liable for any changes, suspension, or discontinuation of the App.'
            ]
          }
        ]
      },
      {
        TITLE: 'Termination',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'We may terminate or suspend your access to the App at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users or the App.'
            ]
          }
        ]
      },
      {
        TITLE: 'Limitation of Liability',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'To the fullest extent permitted by the applicable law, GriffyReads shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the App.'
            ]
          }
        ]
      },
      {
        TITLE: 'Governing Law',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'These Terms shall be governed by and construed in accordance with Belgian law, regardless of whether its conflict of law rules prescribe the application of a different law.'
            ]
          }
        ]
      },
      {
        TITLE: 'Contact Us',
        CONTENT: [
          {
            TYPE: 'TEXT',
            CONTENT: [
              'If you have any questions or concerns about these Terms, please contact us at contact@griffyreads.com.'
            ]
          }
        ]
      }
    ]
  }

export default EN_TERMS_AND_CONDITIONS_PAGE_CONSTANTS
